import { Injectable } from '@angular/core';
import { CodeTextUrlModel } from './code-text-url-model';
import {
    EducationDiscriminatorValues,
    GeneralDiscriminatorValues,
    PayrollDiscriminatorValues,
    PerformanceDiscriminatorValues,
    PersonnelDiscriminatorValues,
    RecruitmentDiscriminatorValues,
} from './code-text-discriminator-values';
import { HrModuleType } from '../../../common/model/hr-module-type';

@Injectable({
    providedIn: 'root',
})
export class CodeTextUrlFactory {
    private codeTextUrlMap = new Map<String, CodeTextUrlModel>();

    constructor() {
        Object.keys(GeneralDiscriminatorValues).map((key) => {
            this.addModel(GeneralDiscriminatorValues[key], HrModuleType.GENERAL);
        });
        Object.keys(PayrollDiscriminatorValues).map((key) => {
            this.addModel(PayrollDiscriminatorValues[key], HrModuleType.PAYROLL);
        });
        Object.keys(PersonnelDiscriminatorValues).map((key) => {
            this.addModel(PersonnelDiscriminatorValues[key], HrModuleType.PERSONNEL);
        });
        Object.keys(PerformanceDiscriminatorValues).map((key) => {
            this.addModel(PerformanceDiscriminatorValues[key], HrModuleType.PERFORMANCE);
        });
        Object.keys(RecruitmentDiscriminatorValues).map((key) => {
            this.addModel(RecruitmentDiscriminatorValues[key], HrModuleType.RECRUITMENT);
        });
        Object.keys(EducationDiscriminatorValues).map((key) => {
            this.addModel(EducationDiscriminatorValues[key], HrModuleType.EDUCATION);
        });
    }

    getCodeTextUrlModel(discriminator: string): CodeTextUrlModel {
        return this.codeTextUrlMap.get(discriminator);
    }

    private addModel(type, moduleType = HrModuleType.PERSONNEL) {
        let model: CodeTextUrlModel = {
            baseUrl: `/${moduleType}CodeTextService/${moduleType}CodeText`,
            port: moduleType,
        };
        this.codeTextUrlMap.set(type, model);
    }
}
